<app-base-topnav-menu></app-base-topnav-menu>
<main class="d-flex flex-column h-100">
  <app-template-header class="flex-shrink-0"></app-template-header>
  <app-template-body class="flex-grow-1"></app-template-body>
</main>
